import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/MyBoard/calendar/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD_ITEM = NAMESPACE + 'ADD_ITEM'
export const ADD_ITEM_ARRAY = NAMESPACE + 'ADD_ITEM_ARRAY'
export const REMOVE_ITEM = NAMESPACE + 'REMOVE_ITEM'
export const REMOVE_ITEM_ARRAY = NAMESPACE + 'REMOVE_ITEM_ARRAY'
export const CLEAR_ITEMS = NAMESPACE + 'CLEAR_ITEMS'
export const SET_START = NAMESPACE + 'SET_START'
export const SET_END = NAMESPACE + 'SET_END'

const initialState = {
  itemIds: [],
  itemsById: {},
  isLoading: false,
  isLoaded: false,
  start: null,
  end: null
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return {
        ...initialState
      }
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case ADD_ITEM:
      return {
        ...state,
        itemIds: addUniqueValueToArray({
          array: state.itemIds,
          value: action.payload.id,
          index: action.payload.index
        }),
        itemsById: {
          ...state.itemsById,
          [action.payload.id]: {
            ...action.payload
          }
        }
      }
    case ADD_ITEM_ARRAY: {
      const newState = {
        ...state,
        itemIds: [ ...state.itemIds ],
        itemsById: { ...state.itemsById }
      }
      action.payload.forEach(item => {
        newState.itemIds = addUniqueValueToArray({
          array: newState.itemIds,
          value: item.id,
          index: item.index
        })
        newState.itemsById[item.id] = {
          ...item
        }
      })
      return newState
    }
    case REMOVE_ITEM: {
      const newState = {
        ...state,
        itemIds: state.itemIds.filter(id => id !== action.payload.id),
        itemsById: { ...state.itemsById }
      }
      delete newState.itemsById[action.payload.id]
      return newState
    }
    case REMOVE_ITEM_ARRAY: {
      const newState = {
        ...state,
        itemIds: state.itemIds.filter(id => action.payload.indexOf(id) === -1),
        itemsById: { ...state.itemsById }
      }
      action.payload.forEach(id => {
        delete newState.itemsById[action.payload.id]
      })
      return newState
    }
    case CLEAR_ITEMS:
      return {
        ...state,
        itemIds: [],
        itemsById: {}
      }
    case SET_START:
      return {
        ...state,
        start: action.payload.start
      }
    case SET_END:
      return {
        ...state,
        end: action.payload.end
      }
    default: return state
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function addItem (data) {
  return {
    type: ADD_ITEM,
    payload: data
  }
}

export function addItemArray (array) {
  return {
    type: ADD_ITEM_ARRAY,
    payload: array
  }
}

export function removeItem ({ id }) {
  return {
    type: REMOVE_ITEM,
    payload: {
      id
    }
  }
}

export function removeItemArray (array) {
  return {
    type: REMOVE_ITEM_ARRAY,
    payload: array
  }
}

export function clearItems () {
  return {
    type: CLEAR_ITEMS
  }
}


export function setStart (start) {
  return {
    type: SET_START,
    payload: {
      start
    }
  }
}

export function setEnd (end) {
  return {
    type: SET_END,
    payload: {
      end
    }
  }
}
